import { SetData } from './SetData';
import { VerifyData } from './VerifyData';

export const Company = {
  SetData,
  VerifyData,
};
